var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#94D357;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M782.74,501.63c31.6,48.55,86.12,80.8,148.36,80.8c97.85,0,177.17-79.34,177.17-177.18 c0-97.86-79.31-177.18-177.17-177.18c-34.87,0-67.16,10.43-94.57,27.82c7.85,24.26,12.2,50.08,12.2,76.92 C848.73,397.89,823.57,457.05,782.74,501.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M939.83,607.23h-29.85c-30.86,0-60.26,6.17-87.16,17.18c61.79,57.49,100.72,139.23,100.72,230.11v170.84 h246.74V837.68C1170.28,710.41,1067.1,607.23,939.83,607.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.3,582.43c58.01,0,109.02-28.29,141.34-71.36c-46.11-45.46-74.8-108.54-74.8-178.25 c0-29.53,5.4-57.75,14.83-84.08c-24.47-12.76-51.86-20.66-81.37-20.66c-97.85,0-177.17,79.31-177.17,177.18 C104.13,503.1,183.45,582.43,281.3,582.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.08,619.61c-23.27-7.9-48.11-12.38-74.05-12.38h-29.85c-127.28,0-230.46,103.18-230.46,230.45v187.68 h228.35V854.52C258.07,761.1,299.22,677.3,364.08,619.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.21,540.94c15.47,3.56,31.52,5.63,48.07,5.63c15.4,0,30.4-1.7,44.88-4.8 c49.11-10.5,91.89-37.88,122.14-75.75c29.19-36.55,46.73-82.8,46.73-133.19c0-18.06-2.49-35.51-6.7-52.25 c-23.35-92.76-107.05-161.5-207.05-161.5c-96.05,0-177.29,63.35-204.23,150.56c-6.17,19.98-9.52,41.19-9.52,63.19 c0,56.38,22,107.52,57.68,145.7C470.75,509.08,508.05,531.23,550.21,540.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M788.2,642.28c-40.03-33.86-89.76-56.49-144.45-63.35c-11.47-1.45-23.09-2.44-34.95-2.44h-36.01 c-8.88,0-17.62,0.52-26.28,1.32c-54.55,5.13-104.39,26.09-145.18,58.13c-64.8,50.9-106.58,129.79-106.58,218.58v170.84v55.58 h592.08v-55.58V854.52C886.84,769.38,848.48,693.28,788.2,642.28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.4e7fb8f3a9febd15278cd8e868a81ce4.svg";
export { ForwardRef as ReactComponent };